import React from 'react';
import { styled } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import AsyncIcon from '@atlassian/jira-common-components-async-icon/src/view.tsx';
import {
	MiniHeader as MinimizableModalHeader,
	ModalTitle,
} from '@atlassian/jira-minimizable-modal/src/ui/modal-container/modal-header/index.tsx';
import type { MiniHeaderProps } from './types.tsx';

const renderIcon = (iconUrl: string) => {
	return (
		<Box
			testId="issue-create.common.ui.minimizable-modal-mini-header.icon-container"
			xcss={containerStyles}
		>
			<AsyncIcon width={16} url={iconUrl} />
		</Box>
	);
};

export const MiniHeader = ({
	title,
	iconUrl,
	isItalic,
	showHeaderIcon,
	dismissModalEntryPointWrapper,
}: MiniHeaderProps) => (
	<MinimizableModalHeader dismissModalEntryPointWrapper={dismissModalEntryPointWrapper}>
		{showHeaderIcon && iconUrl && renderIcon(iconUrl)}

		<MinimizableModalTitle
			/* eslint-disable-next-line jira/integration/test-id-by-folder-structure */
			testId="minimizable-modal.ui.modal-container-mini-header.mini-header"
			// @ts-expect-error - TS2322 - Type '{ children: string; "data-testid": string; isItalic: boolean; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<ThemedOuterStyledProps<WithOptionalTheme<{ children?: ReactNode; }, any>, any>, any, any>> & Readonly<...>'.
			isItalic={isItalic}
		>
			{title}
		</MinimizableModalTitle>
	</MinimizableModalHeader>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const MinimizableModalTitle = styled(ModalTitle)({
	display: '-webkit-box',
	color: token('color.text'),
	font: token('font.heading.small'),

	paddingTop: 0,
	paddingRight: token('space.100'),
	paddingBottom: 0,
	paddingLeft: token('space.100'),
	WebkitLineClamp: 2,
	WebkitBoxOrient: 'vertical',
	whiteSpace: 'normal',
	textOverflow: 'normal',
	overflow: 'hidden',
});

const containerStyles = xcss({
	width: token('space.300'),
	height: token('space.300'),
	marginRight: 'space.050',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});
